$(document).ready(function(){
    $('.product__description .read-more .action-link').on('click', function(){
        if($('.product__description .full-text').is(':visible')){
            $(this).text("Read more");
            $('.product__description .full-text').hide();
            $('.product__description .intro').show();
        } else {
            $(this).text("Read less");
            $('.product__description .intro').hide();
            $('.product__description .full-text').show();
        }
    });
    const $selectedRadio = $('input[name=power]:checked');
    // $('input[name=power]').on('change', function(){
        if($selectedRadio.val() == 0){
            $('#has-power-wrap').hide();
            $('#no-power-wrap').show();

            //checkbox validation
            $('input[name=prescription]').prop('checked', false);
            $('p.error').removeClass('error-show');
            $('input[name=prescription]').removeClass('error-box');
            $('#color-addtocart').removeClass('disabled');
            //$('#color-addtocart .price__per-eye').hide();
            if($selectedRadio.data('available') == false){
                $('#color-addtocart').addClass('sold-out');
                $('#color-addtocart .btn-text').text(theme.strings.soldOut);
                $('.error-msg').text('This item is currently out of stock in non-prescription.');
            } else {
                $('#color-addtocart').removeClass('sold-out');
                if($('input[name=pre-order]').val() == 'true'){
                    $('#color-addtocart .btn-text').text(theme.strings.preOrder);
                } else {
                    $('#color-addtocart .btn-text').text(theme.strings.addToCart);
                }
                
                $('.error-msg').text('');
            }
        } else {
            if($selectedRadio.hasClass('prescription-check')){
                $('#color-addtocart').addClass('disabled');
            }
            $('#no-power-wrap').hide();
            $('#has-power-wrap').show();
            
            if($('#both-variant').find('option[data-available=true]').length == 0){
                $('#color-addtocart').addClass('sold-out');
                $('#color-addtocart .btn-text').text(theme.strings.soldOut);
                $('.error-msg').text('This item is currently out of stock in non-prescription.');
            } else {
                $('#color-addtocart').removeClass('sold-out');
                if($('input[name=pre-order]').val() == 'true'){
                    $('#color-addtocart .btn-text').text(theme.strings.preOrder);
                } else {
                    $('#color-addtocart .btn-text').text(theme.strings.addToCart);
                }
                
                $('.error-msg').text('');
            }
        }
    // });

    $('input[name=different-power]').on('change', function(){
        if($(this).is(':checked')){
            $('#prescription-same').hide();
            $('#prescription-group').show();
        } else {
            $('#prescription-group').hide();
            $('#prescription-same').show();
        }
    });

    var callbackAddtocart = function(err = null){
        //console.log('callback', {err});
        if(err){
            $('.error-msg').text(err.responseJSON.description);
        }
        document.dispatchEvent(new CustomEvent('productAddedToCart'));
        window.carts.forEach((cart) => {
            cart.onCartUpdated();
        });
        
        document.querySelector('.header__icons .header__icon--cart').click();
    };
    $('input[name=prescription]').on('change', function(){
        if($(this).prop('checked')) {
            $('#color-addtocart').removeClass('disabled');
            $('p.error').removeClass('error-show');
            $('input[name=prescription]').removeClass('error-box');
        } else {
            $('#color-addtocart').addClass('disabled');
        }
    });

    $('#color-addtocart').on('click', function(){
        if($(this).hasClass('disabled')){
            if (!$('input[name=prescription]').attr('checked')) {
                $('p.error').addClass('error-show');
                $('input[name=prescription]').addClass('error-box');
            } 
            return false;
        }
        if($(this).hasClass('sold-out')){
            return false;
        }
        
        var item = {};
        if($('input[name=pre-order]').val() == 'true'){
          item["properties[Pre-order]"] = "This is a pre-order item.";
        }

        if($('input[name=power]:checked').val() == 0) {
            item["id"] = $('input[name=no-power-id]').val();
            item["quantity"] = $('#qty-no-power').val();              
            //item["properties[Eye]"] = 'Both';
            var data = JSON.parse(JSON.stringify(item));
          
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function(res){
                    callbackAddtocart();
                },
                error: function(err){
                    callbackAddtocart(err);
                }
            });
        } else if($('#different-power').is(':checked')){
            var left_id = $('#left-variant').val();
            var right_id = $('#right-variant').val();
            if(left_id == right_id) {
                item["id"] = left_id;
                item["quantity"] = parseInt($('#qty-left-power').val()) + parseInt($('#qty-right-power').val());              
                //item["properties[Eye]"] = 'Both';
                var data = JSON.parse(JSON.stringify(item));
            
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    dataType: 'json',
                    success: function(res){
                        //console.log({res});
                        callbackAddtocart();
                    },
                    error: function(err){
                        callbackAddtocart(err);
                    }
                });
            } else {
                item["id"] = right_id;
                item["quantity"] = $('#qty-right-power').val();              
                //item["properties[Eye]"] = 'Right';
                var data = JSON.parse(JSON.stringify(item));
            
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    dataType: 'json',
                    success: function(res1) {
                        console.log({res1});
                        item["id"] = left_id;
                        item["quantity"] = $('#qty-left-power').val(); 
                        //item["properties[Eye]"] = 'Left';
                        var data = JSON.parse(JSON.stringify(item));
                    
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: data,
                            dataType: 'json',
                            success: function(res2){
                                //console.log({res2});
                                callbackAddtocart();
                            },
                            error: function(err){
                                callbackAddtocart(err);
                            }
                        });
                    },
                    error: function(err){
                        callbackAddtocart(err);
                    }
                });
            }
        } else {
            item["id"] = $('#both-variant').val();
            item["quantity"] = $('#qty-same-power').val();              
            //item["properties[Eye]"] = 'Both';
            var data = JSON.parse(JSON.stringify(item));
        
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function(res){
                    console.log({res});
                    callbackAddtocart();
                },
                error: function(err){
                    callbackAddtocart(err);
                }
            });
        }

    });

    //Close add to cart popup
    $('.added-wrapper .close-added').on('click', function(){
        $('.added-wrapper').removeClass('open');
    });

    //Before & After image slider
    $.fn.BeerSlider = function ( options ) {
        options = options || {};
        return this.each(function() {
            new BeerSlider(this, options);
        });
    };
    $('.beer-slider').BeerSlider({ start: 50 });

    //Product info accordion
    $(".accordion-head").on('click',function(){
        $('.accordion-wrap.active').removeClass('active');
        $('.accordion-body:visible').slideUp(300);
        if( $(this).next(".accordion-body").is(':hidden')){
            $(this).next(".accordion-body").slideDown(300);
            $(this).closest('.accordion-wrap').addClass('active');
        }
    });

});